<mat-form-field
  class="field"
  [class.field-density-5]="prefix()"
  subscriptSizing="dynamic"
>
  @if (prefix()) {
    <mat-icon matIconPrefix>language</mat-icon>
  }
  @if (placeholder()) {
    <mat-label>{{ placeholder() }}</mat-label>
  }
  <mat-select (selectionChange)="handleChange($event)" [ngModel]="model()">
    @for (language of languages(); track language.value) {
      <mat-option [attr.value]="language.value" [value]="language.value">{{
        language.viewValue
      }}</mat-option>
    }
  </mat-select>
</mat-form-field>
